export { default } from "./LeftPanel";
